import type { Image, Persisted } from '@tunasong/schemas'
import type { FC, HTMLAttributes } from 'react'
import { useImage } from '../hooks/image.hook.js'

interface HeaderImageProps extends HTMLAttributes<HTMLDivElement> {
  image: Persisted<Image>
}

const headerImgStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  maxHeight: 200,
  objectFit: 'cover',
  border: 'none',
  maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
}

const HeaderImg = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img {...props} style={{ ...headerImgStyle, ...props.style }} />
)

export const HeaderImage: FC<HeaderImageProps> = props => {
  const { image, style, ...divProps } = props
  const url = useImage(image, 'large')

  return (
    <div {...divProps} style={{ backgroundColor: 'var(--tuna-palette-background-paper)', opacity: 0.4, ...style }}>
      <HeaderImg src={url} />
    </div>
  )
}
